import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { filter, pairwise } from 'rxjs/operators';

import { MsalService } from './msal.service';
import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationResult, InteractionType } from "@azure/msal-browser";
import { MsalGuardConfiguration } from './msal.guard.config';
import { MSAL_GUARD_CONFIG } from './constants';
import { concatMap, catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NgSessionStorage, NgLocalStorage } from 'core/utils/ng-storage.service';

import { AuthenticationService } from 'core/authentication.service';

@Injectable()
export class MsalGuard implements CanActivate {
    constructor(
        @Inject(DOCUMENT) private readonly document: any,
        private router: Router,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private location: Location,
        private ngLocalStorage: NgLocalStorage,
        private ngSessionStorage: NgSessionStorage
    ) { }
    /**
     * Builds the absolute url for the destination page
     * @param path Relative path of requested page
     * @returns Full destination url
     */
    getDestinationUrl(path: string): string {
        // Absolute base url for the application (default to origin if base element not present)
        const baseElements = document.getElementsByTagName("base");
        const baseUrl = this.location.normalize(baseElements.length ? baseElements[0].href : window.location.origin);
        // Path of page (including hash, if using hash routing)
        const pathUrl = this.location.prepareExternalUrl(path);

        // Hash location strategy
        if (pathUrl.startsWith("#")) {
            return `${baseUrl}/${pathUrl}`;
        }
        // If using path location strategy, pathUrl will include the relative portion of the base path (e.g. /base/page).
        // Since baseUrl also includes /base, can just concatentate baseUrl + path
        return `${baseUrl}${path}`;
    }


    private loginInteractively(url: string): Observable<boolean> {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            return this.authService.loginPopup({ ...this.msalGuardConfig.authRequest })
                .pipe(
                    map((response: AuthenticationResult) => {
                        this.authService.instance.setActiveAccount(response.account);
                        //this.router.navigate(['dashboard']);
                        window.location.href = `${this.document.location.origin}/#/dashboard`;
                        return true;
                    }),
                    catchError(() => of(false))
                );
        }
        const redirectStartPage = this.getDestinationUrl(url);
        this.authService.loginRedirect({
            redirectStartPage,
            ...this.msalGuardConfig.authRequest,
        });
        return of(false);
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.authService.handleRedirectObservable()
            .pipe(
                catchError((err) => {
                    // First-time login can land on a non-auth hash or stale state.
                    // Do not break routing; continue with normal account/login checks.
                    console.log(err);
                    return of(null);
                }),
                concatMap((redirectResult: AuthenticationResult | null) => {
                    if (redirectResult?.account) {
                        this.authService.instance.setActiveAccount(redirectResult.account);
                        this.saveUserPreferences(redirectResult.account);
                    }

                    var allAccounts = this.authService.instance.getAllAccounts();
                    if (!allAccounts.length) {
                        return this.loginInteractively(state.url);
                    }
                    else {
                        const activeAccount: any = allAccounts[0];
                        const roles = activeAccount.idTokenClaims.roles;
                        let hasaccess = false;
                        if (route.data) {
                            for (var i in route.data.roles) {
                                for (var j in roles) {
                                    if (route.data.roles[i] === roles[j]) {
                                        hasaccess = true;
                                        break;
                                    }
                                }
                            }
                        }
                        // else {
                        //     return of(true);
                        // }
                        this.authService.instance.setActiveAccount(activeAccount);
                        this.saveUserPreferences(activeAccount);

                        return of(true);
                    }
                })
            );
    }
    private saveUserPreferences(account: any) {
        let globals = {
            UserId: account.idTokenClaims.preferred_username,
            UserName: account.name
        };
        this.ngLocalStorage.setItem('userDetail', JSON.stringify(globals));
    }

}
